module.exports = __webpack_public_path__ + "static/media/41.1ee2870e.jpg";